function seperatorMessageFormatter (type, message, timestamp, component = 'EndChatSeparator') {
    const seperatorMessage = {
        isMessageSeparator: true,
        content: {
          component,
          message,
          type: type || 'CONFIG'
        },
        timestamp: timestamp,
        messages: []
    }
    return seperatorMessage
}

export default seperatorMessageFormatter
